import { createSlice } from '@reduxjs/toolkit';

import { StationsState } from '../../types';

import { STATIONS_STATE } from '../../constants';

import { setStationsWithPrices } from './setStationsWithPrices';
import { resetStationWithPrices } from './resetStationWithPrices';
import { setRouteStationsPrices } from './setRouteStationsPrices';
import { setBestRouteStations } from './setBestRouteStations';
import { setMarkerServiceStations, setPricesServiceMapData } from './setMarkerServiceStations';
import { setSelectedStation } from './setSelectedStation';
import { removeSelectedStationOnRoute } from './removeSelectedStationOnRoute';
import { resetSelectedStation } from './resetSelectedStation';
import { setStationsDisplay } from './setStationsDisplay';
import { setRouteStationsWithPrices } from './setRouteStationsWithPrices';

import { setFavouriteStations } from './setFavouriteStations';
import { addFavouriteStations } from './addFavouriteStations';
import { deleteFavouriteStations } from './deleteFavouriteStations';
import { resetDeletingStatus } from './resetDeletingStatus';
import { setAddingFavouriteStationsStatus } from './setAddingFavouriteStationsStatus';

const initialState: StationsState = {
  stationsWithPrices: {},
  routeStationsPrices: {},
  bestRouteStations: {},
  markerServiceStations: {},
  selectedStation: {},
  routesStationsWithPrices: {},
  display: true,
  favouriteStations: {},
};

export const stationsSlice = createSlice({
  name: STATIONS_STATE,
  initialState,
  reducers: {
    resetStationWithPrices,
    setBestRouteStations,
    setMarkerServiceStations,
    setPricesServiceMapData,
    setSelectedStation,
    removeSelectedStationOnRoute,
    resetSelectedStation,
    setStationsDisplay,
    setRouteStationsWithPrices,

    resetDeletingStatus,
    setAddingFavouriteStationsStatus,
  },
  extraReducers: (builder) => {
    setStationsWithPrices(builder);
    setRouteStationsPrices(builder);

    setFavouriteStations(builder);
    addFavouriteStations(builder);
    deleteFavouriteStations(builder);
  },
});

export const stationsActions = stationsSlice.actions;
export const stationsReducer = stationsSlice.reducer;
